import React, { useEffect } from 'react';
import withRouter from '../Components/Common/withRouter';
import { useLayoutStore } from "../stores/useLayoutStore";

const NonAuthLayout = ({ children }: any) => {
    const layoutModeType = useLayoutStore((s) => s.layoutModeType);

    useEffect(() => {
        if (layoutModeType === "dark") {
            document.body.setAttribute("data-bs-theme", "dark");
        } else {
            document.body.setAttribute("data-bs-theme", "light");
        }
        return () => {
            document.body.removeAttribute("data-bs-theme")
        }
    }, [layoutModeType]);
    return (
        <div>
            {children}
        </div>
    );
};

export default withRouter(NonAuthLayout);